import { render } from "./CandidatesFilters.component.vue?vue&type=template&id=294e9e95&scoped=true"
import script from "./CandidatesFilters.component.vue?vue&type=script&lang=js"
export * from "./CandidatesFilters.component.vue?vue&type=script&lang=js"

import "./CandidatesFilters.component.vue?vue&type=style&index=0&id=294e9e95&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-294e9e95"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QChip from 'quasar/src/components/chip/QChip.js';import ClosePopup from 'quasar/src/directives/close-popup/ClosePopup.js';
import qInstall from "../../../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QChip});qInstall(script, 'directives', {ClosePopup});
